var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddress(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#0B319D",
    height: 48,
    width: 48,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 36.9q-6.85-5.15-10.175-9.85-3.325-4.7-3.325-9.25 0-3.4 1.225-5.975Q12.95 9.25 14.9 7.5q1.95-1.75 4.35-2.625Q21.65 4 24 4t4.75.875q2.4.875 4.35 2.625 1.95 1.75 3.175 4.325Q37.5 14.4 37.5 17.8q0 4.55-3.325 9.25T24 36.9ZM24 21q1.45 0 2.475-1.025Q27.5 18.95 27.5 17.5q0-1.45-1.025-2.475Q25.45 14 24 14q-1.45 0-2.475 1.025Q20.5 16.05 20.5 17.5q0 1.45 1.025 2.475Q22.55 21 24 21ZM10.5 44v-3h27v3Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddress);
export default __webpack_public_path__ + "static/media/address.10ff90cc64cdc0ed4da3f53a77ce0c18.svg";
export { ForwardRef as ReactComponent };